import React, { useRef, ReactElement } from 'react'
import Timer from 'react-compound-timer/build'

import { useMachine } from '@xstate/react'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

import useLoginMachine from '../../hooks/useLoginMachine'
import Login from '../../components/Login/Login'
import { LOGIN_VERSION, LoginVersionEnum } from '../../constants/loginConstants'
import LoginV2 from '../../components/LoginV2/LoginV2'

const LoginController = (): ReactElement => {
   const timerRef = useRef<{
      start: () => void
   } | null | null>(null)

   const { loginMachine } = useLoginMachine({ timerRef })

   const [loginMachineState, loginMachineSend] = useMachine(loginMachine, {
      devTools: false
   })

   const isOfficerPortalAppClientEnum =
      Config.APP_CLIENT_ENUM === 'MA&UD_ADMIN' ||
      Config.APP_CLIENT_ENUM === 'AP_MA&UD'

   const isB2gTgLoginVersion =
      LOGIN_VERSION === LoginVersionEnum.B2G_TG_LOGIN &&
      isOfficerPortalAppClientEnum

   const isDefaultFlowwLoginVersion =
      LOGIN_VERSION === LoginVersionEnum.DEFAULT_CRM_LOGIN

   const renderLoginBasedOnVersion = (): React.ReactElement => {
      switch (true) {
         case isB2gTgLoginVersion: {
            return (
               <LoginV2
                  loginMachineState={loginMachineState}
                  loginMachineSend={loginMachineSend}
                  timerRef={timerRef}
               />
            )
         }

         case isDefaultFlowwLoginVersion:
         default: {
            return (
               <Login
                  loginMachineState={loginMachineState}
                  loginMachineSend={loginMachineSend}
                  timerRef={timerRef}
               />
            )
         }
      }
   }

   return renderLoginBasedOnVersion()
}

export default LoginController
